import { render, staticRenderFns } from "./CheeseTijd.vue?vue&type=template&id=cb769e38&scoped=true"
import script from "./CheeseTijd.vue?vue&type=script&lang=js"
export * from "./CheeseTijd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb769e38",
  null
  
)

export default component.exports